<template>
  <v-dialog :value="dialog" width="500" persistent>
    <v-card class="pa-4">
      <div class="f20 fw500 mb-6 text-center" style="white-space: pre-line">
        {{
          'Запись аудио' +
          '\n' +
          'время записи' +
          ' (' +
          millisToMinutesAndSeconds(recordingTime) +
          '/' +
          millisToMinutesAndSeconds(maxRecordingTime) +
          ')'
        }}
      </div>
      <div class="d-grid grid-col-max-1 align-center gap-2">
        <v-hover v-slot="{ hover }">
          <v-btn
            @click="readyToRecord ? recordStart() : recordStop()"
            fab
            dark
            small
            :color="readyToRecord ? 'primary' : 'red'"
          >
            <v-icon dark
              >{{
                readyToRecord
                  ? 'mdi-microphone-plus'
                  : hover
                  ? 'mdi-microphone-message-off'
                  : 'mdi-microphone-message'
              }}
            </v-icon>
            <v-progress-circular
              v-show="recordStatus === 'recording'"
              class="ccs"
              :rotate="-90"
              :size="45"
              :width="5"
              :value="(recordingTime / maxRecordingTime) * 100"
              color="primary"
            />
          </v-btn>
        </v-hover>
        <AudioPlayer :src="audioFile" :class="{ disabled: !readyToRecord || !audioFile }" />
      </div>
      <div class="mt-4 d-flex justify-center gap-4">
        <BaseButton
          @click="onCloseDialog"
          :text="localStorage.translations.pages.common.buttons.otmenit"
          default_icon="button-back"
          reverse
        />
        <BaseButton
          v-if="audioFile"
          @click="onSaveBlobToFile"
          :text="localStorage.translations.pages.common.buttons.confirm"
          default_icon="button-confirm"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import AudioPlayer from 'components/base/file/AudioPlayer'
export default {
  name: 'BaseAudioRecord',
  components: {
    AudioPlayer,
  },
  props: {
    value: [File],
  },
  data() {
    return {
      dialog: false,
      device: null,
      recorder: null,
      audioFile: null,
      recordStatus: 'inactive',
      maxRecordingTime: 30000,
      recordingTime: 0,
    }
  },
  computed: {
    readyToRecord() {
      return this.recordStatus === 'inactive'
    },
  },
  watch: {
    recorder() {
      console.log(this.recorder.state)
    },
    dialog() {
      if (!this.dialog) {
        this.device = null
        this.recorder = null
        this.audioFile = null
        this.recordStatus = 'inactive'
        this.recordingTime = 0
      }
    },
  },
  methods: {
    onOpenDialog() {
      this.dialog = true
    },
    onCloseDialog() {
      this.dialog = false
    },
    onSaveBlobToFile() {
      this.$emit('input', new File([this.audioFile], 'Record ' + new Date().timeNow))
      this.onCloseDialog()
    },
    recordStart() {
      this.device = navigator.mediaDevices.getUserMedia({ audio: true })
      let chunks = []
      let timerId = null
      this.device.then((stream) => {
        const options = {
          // mimeType: 'audio/webm',
        }
        this.recorder = new MediaRecorder(stream, options)

        this.recorder.ondataavailable = (e) => {
          console.log('ondataavailable', e)
          chunks.push(e.data)
          this.recordStatus = e.target.state
        }
        this.recorder.onstart = (e) => {
          console.log('onstart', e)
          this.recordingTime = 0
          this.recordStatus = e.target.state
          timerId = setInterval(() => {
            if (this.recordingTime < this.maxRecordingTime - 500) {
              this.recordingTime += 500
            } else {
              if (this.recorder.state !== 'inactive') {
                this.recordStop()
              }
            }
          }, 500)
        }
        this.recorder.onstop = (e) => {
          console.log('onstop', e)
          console.log('chunks', chunks)
          let blob = new Blob(chunks, { type: 'audio/webm' })
          this.audioFile = window.URL.createObjectURL(blob)
          console.log('blob', blob)
          // this.audioFile = new File(chunks, 'Record')
          console.log('audioFile', this.audioFile)
          stream.getAudioTracks()[0].stop()
          this.recordStatus = e.target.state
          clearInterval(timerId)
        }
        this.recorder.start()

        // I do not want a timeout to stop the recording but clicking the stop button to do so
      })
    },
    recordStop() {
      this.recorder.stop()

      console.log('MediaRecorder', this.recorder)
    },
    millisToMinutesAndSeconds(millis) {
      var minutes = Math.floor(millis / 60000)
      var seconds = ((millis % 60000) / 1000).toFixed(0)
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds
    },
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  filter: blur(1px);
}
.ccs {
  position: absolute;
  :deep().v-progress-v-progress-circular__overlay {
    stroke: #9e9e9e66 !important;
  }
}
</style>
